import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { transformMerchantRestrictionsMetaPayload } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/MerchantRestrictionsRule/utils/transformMerchantData';
import {
  GroupRestrictions,
  groupRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

import {
  useOrderRestrictionContext,
  OrderRestrictionsContextType,
} from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';

type UseMealCreditMerchantRestrictionsReturn = {
  groupedMerchantRestrictions: GroupRestrictions;
} & OrderRestrictionsContextType;

export function useMealCreditMerchantRestrictions(): UseMealCreditMerchantRestrictionsReturn {
  const { mealCredit } = useMealCreditFormData();
  const { isLoading, merchantRestrictionsMeta, error } =
    useOrderRestrictionContext();

  const getGroupedMerchantRestrictions = (): GroupRestrictions => {
    let tempRestrictions = null;
    if (error && mealCredit?.merchant_restrictions) {
      tempRestrictions = transformMerchantRestrictionsMetaPayload(
        mealCredit.merchant_restrictions
      );

      return groupRestrictions(tempRestrictions);
    }

    return groupRestrictions(merchantRestrictionsMeta || []);
  };

  return {
    merchantRestrictionsMeta,
    isLoading,
    groupedMerchantRestrictions: getGroupedMerchantRestrictions(),
  };
}
